/* eslint-disable no-extra-boolean-cast */
import { Box, Icon, IconButton, InputAdornment, Tooltip } from "@mui/material";
import MDInput from "components/Basics/MDInput";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { display } from "redux-react/reducers/snackBarReducer";
import { v4 } from "uuid";
import lod_ from "lodash";

const generateHash = () => {
	return v4();
};

/**
 * Special input for webhook
 * @returns
 */
const InputWebhook = ({ label, value, item, onChange, apiKey }) => {
	const dispatch = useDispatch();
	const [hash, setHash] = useState(value);
	const [visibleInput, setVisibleInput] = useState(true);
	const [visibleApiKey, setVisibleApiKey] = useState("");

	const baseUrl = item?.webhook?.baseUrl;
	const url = `${baseUrl}${hash}?apiKey=${visibleApiKey}`;
	// Regenerate the API key
	const regenerate = () => {
		const newHash = generateHash();
		setHash(newHash);
		onChange(newHash);
	};

	useEffect(() => {
		if (!value) {
			regenerate();
		}
	}, []);

	useEffect(() => {
		if (lod_.isNil(apiKey) || lod_.isEmpty(apiKey)) {
			setVisibleInput(false);
			setVisibleApiKey("");
		} else {
			setVisibleInput(true);
			setVisibleApiKey(apiKey);
		}
	}, [apiKey]);

	return visibleInput ? (
		<MDInput
			fullWidth
			label={label}
			value={url}
			disabled
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<Tooltip placement="top" title={t("SETTINGS.regenerate")}>
							<IconButton color="info" style={{ pointerEvents: "visible" }} onClick={regenerate}>
								<Icon>autorenew</Icon>
							</IconButton>
						</Tooltip>
						<Tooltip placement="top" title={t("SETTINGS.DICTIONARY.copyToClipboard")}>
							<IconButton
								color="info"
								style={{ pointerEvents: "visible" }}
								onClick={() => {
									navigator.clipboard.writeText(url);
									dispatch(
										display({
											message: t("FORMS.copyToClipboard"),
											type: "info"
										})
									);
								}}
							>
								<Icon>copy</Icon>
							</IconButton>
						</Tooltip>
					</InputAdornment>
				)
			}}
		/>
	) : (
		<Box></Box>
	);
};
export default InputWebhook;
